---
title: "Initial Setup"
slug: initial-setup
description: "Step-by-step guide to setting up locations, external destinations, and users in hey circle."
keywords:
  - initial setup
  - location
  - users
  - roles
  - external destination
  - setup
  - Shopify
---

## Prerequisites

- Role: Company Admin
- Your company must be registered in hey circle

## Steps

Carry out the following steps in this order:

### 1. Create internal locations

1. Navigate to **Settings → Scan Locations** in the top menu.
2. Click **Create new location** and enter the name and address.
3. Create at least one location — users with the Scanner role need an assigned location before they can scan.

### 2. Create external destinations (optional)

1. Navigate to **Settings → Recipients** in the top menu.
2. Click **Create new external destination** and fill in the name and address.
3. External destinations are recipients outside your own locations, to whom you send packages (for example customers or partners).

### 3. Create users and assign roles

1. Navigate to **Settings → Users** in the top menu.
2. Click **Invite user** and enter the new user's email address.
3. Select the appropriate role:

| Permission | Company Admin | Company Manager | Scanner |
|---|---|---|---|
| Manage users | ✓ | | |
| Manage integrations (Shopify) | ✓ | | |
| Billing | ✓ | | |
| Create / edit locations | ✓ | ✓ | |
| Create / edit external destinations | ✓ | ✓ | |
| View analytics | ✓ | ✓ | |
| Scan packages (Send / Receive) | ✓ | ✓ | ✓ |
| View inventory list | ✓ | ✓ | ✓ |
| View contracts | ✓ | ✓ | |

4. Assign at least one internal location to each user with the Scanner role.

### 4. Connect Shopify integration (optional)

If you use Shopify: navigate to **Settings → Integrations** in the top menu and connect your shop. This setting is only available to Company Admins.

### 5. Begin operations

After completing setup, your Scanner users can start scanning immediately. Inventory is created automatically through scan events — there is no separate step to create inventory. For more details, see the inventory concept article.

## If something goes wrong

- **User does not receive invitation email** — Check the spam folder. If the email does not arrive, delete the invitation and resend it.
- **Scanner cannot scan** — Make sure the user has at least one internal location assigned.
- **Location dropdown empty in scanner view** — The user has no assigned location yet. Assign one in User Management.
- Contact us: support@heycircle.com or use the feedback button in the bottom-right corner of the screen.

## Related Articles

- [Sending a Package](/app/help?article=sending-a-package)
- [Receiving a Package](/app/help?article=scanning-a-package)
- [Reading the Analytics Dashboard](/app/help?article=viewing-analytics)
